import { render, staticRenderFns } from "./SectionComparison.vue?vue&type=template&id=72b2da2d&"
import script from "./SectionComparison.vue?vue&type=script&lang=js&"
export * from "./SectionComparison.vue?vue&type=script&lang=js&"
import style0 from "./SectionComparison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports